import { render, staticRenderFns } from "./Rack.vue?vue&type=template&id=b81fc4b4&scoped=true&"
import script from "./Rack.vue?vue&type=script&lang=js&"
export * from "./Rack.vue?vue&type=script&lang=js&"
import style0 from "./Rack.vue?vue&type=style&index=0&id=b81fc4b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81fc4b4",
  null
  
)

export default component.exports